const AnnouncementBar = () => {
    return (
        <h5 className='announcement-bar'>
                <span className='announcement-text'>Sovelluksella saat ilmoitukset uusista takaisinvedoista! </span>
                <a
                href="https://play.google.com/store/apps/details?id=fi.takaisinvedot.app&utm_source=web&utm_medium=announcementBar&utm_campaign=android_from_web"
                target="_blank"
                rel="noopener noreferrer"
                className="google-play-badge"
                >
                    <img
                        src="./GetItOnGooglePlay_Badge_Web_color_Finnish.svg"
                        style={{ width: '100px', marginLeft: '10px', verticalAlign: 'middle' }}
                        alt="Lataa sovellus Google Playsta"
                    />
                </a>
            </h5>
    )
}
export default AnnouncementBar